import {Injectable} from "@angular/core";
import {Router} from "@angular/router";

export type SerializableError = {
  name: string;
  message: string;
  stack?: string;
} | Record<string, unknown> | string | object

@Injectable({ providedIn: 'root' })
export class ErrorNavigationService {
  constructor(private router: Router) {}

  navigateToErrorPage(error: unknown, args?: { title?: string }): void {
    // Optionally shape the error into a serializable format
    const safeError = this.serializeError(error);

    this.router.navigateByUrl('/error', {
      state: { error: safeError }
    }).catch(console.error);
  }

  private serializeError(error: unknown): SerializableError {
    if (error instanceof Error) {
      return {
        name: error.name,
        message: error.message,
        stack: error.stack
      };
    }

    // Remove known uncloneable objects
    if (error instanceof Event) {
      return { name: 'EventError', message: error.type };
    }

    try {
      // Attempt to clone or stringify safely
      JSON.stringify(error); // throws if circular
      return error as object;
    } catch {
      return { message: String(error) };
    }
  }
}
